import { createFileRoute, redirect } from "@tanstack/react-router"

/**
 * `/` — the customer lands on the hub, which lists whatever modules they
 * hold. Redirecting into a module instead would pick one by manifest
 * order, which is arbitrary from the customer's side.
 */
export const Route = createFileRoute("/")({
  beforeLoad: () => {
    throw redirect({ to: "/home" })
  },
})
